export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f4b2efb74b5877af998b8e796784ad9f0008e5420&name=fetchTypeahead!'